import Route from '@ember/routing/route';

export default class AuthenticatedReimaginedSyfRoute extends Route {}
